import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../_service/auth.service';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/shared/_service/session.service';
import { ApiService } from 'src/app/shared/_service/api.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
})
export class AuthLoginComponent implements OnInit, OnDestroy {
	constructor(
		private router: Router,
		private session: SessionService,
		private auth: AuthService,
		private api: ApiService,
		private translate: TranslateService,
	) {}

	username;
	password;

	ngOnInit() {}

	login() {
		this.auth.login(this.username, this.password).subscribe(() => {
			this.session.getProdotti().subscribe();
			this.session.getCarrello().subscribe();
			this.router.navigate(['']);
			this.api.listDizionari({ codice_lingua: environment.lang }).subscribe((res) => {
				const translations = this.translate.translations;
				res.forEach(({ idBertazzoni, valore }) => {
					translations[environment.lang][idBertazzoni] = valore;
				});
				this.translate.setTranslation(environment.lang, translations[environment.lang]);
				console.log('Mappa valori e traduzioni', this.translate.translations);
			});
		});
	}

	ngOnDestroy() {}
}
